// ======================================================
//        deliveryNote_header
// ======================================================

export const GET_DELIVERYNOTE_HEADER = "GET_DELIVERYNOTE_HEADER";
export const GET_DELIVERYNOTE_HEADER_UPDATE = "GET_DELIVERYNOTE_HEADER_UPDATE";
export const COPY_DELIVERYNOTE_HEADER = "COPY_DELIVERYNOTE_HEADER";
export const DELIVERYNOTES_WITHLINES = 'DELIVERYNOTES_WITHLINES'
export const GET_DELIVERYNOTE_DATA = "GET_DELIVERYNOTE_DATA";

// ======================================================
//         deliveryNote_lines
// ======================================================

export const GET_DELIVERYNOTE_LINES = "GET_DELIVERYNOTE_LINES";
export const GET_DELIVERYNOTE_LINES_UPDATE = "GET_DELIVERYNOTE_LINES_UPDATE";
export const COPY_DELIVERYNOTE_LINES = "COPY_DELIVERYNOTE_LINES";